import React from 'react';
import { translate } from '../../i18n';

interface PaxPercentageProps {
  allocatedPax: number;
  capacity: number;
  className?: string;
}

const PaxPercentageBarSection: React.FC<PaxPercentageProps> = ({
  capacity,
  allocatedPax,
  className,
}) => {
  const dynamicFilledPercentage = ((allocatedPax / capacity) * 100).toFixed(0);
  return (
    <div>
      <div className="flex items-center space-x-2">
        <div className="w-full bg-[#C2F3D6] rounded-full h-2 relative">
          <div
            className={`${Number(dynamicFilledPercentage) < 101 ? 'bg-[#22AD5C]' : 'bg-red-500'}  h-2 rounded-full`}
            style={{
              width: `${Number(dynamicFilledPercentage) < 101 ? dynamicFilledPercentage : 100}%`,
            }}
          ></div>
        </div>
      </div>
      <p className={`text-[#626262] text-sm mb-2 mp-px mt-2 ${className || 'text-left'}`}>
        {dynamicFilledPercentage ? dynamicFilledPercentage : 0}% {translate('operation.filled')}
      </p>
    </div>
  );
};

export default PaxPercentageBarSection;